import Chip from '@mui/material/Chip';
import type { SxProps, Theme } from '@mui/material/styles';
import type { FC } from 'react';

interface DraftBadgeProps {
  /** Optional label override (e.g. "Archived"). Defaults to "Draft". */
  label?: string;
  sx?: SxProps<Theme>;
}

/**
 * Small status chip shown next to unpublished content while preview mode is on,
 * so reviewers can tell at a glance what is not yet live for members.
 */
export const DraftBadge: FC<DraftBadgeProps> = ({ label = 'Draft', sx }) => (
  <Chip label={label} color="warning" size="small" variant="filled" sx={{ height: 18, fontSize: 10, ...sx }} />
);
